<template>
    <div
        class="fixed z-50 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 text-center sm:block sm:p-0">
            <div
                class="fixed inset-0 bg-black bg-opacity-80 transition-opacity"
                aria-hidden="true"
            ></div>

            <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
            >&#8203;</span>

            <div
                class="max-h-[80%] inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle w-full"
                :class="width[size]"
            >
                <div class="bg-white py-6 pb-[40px] ">
                    <div>
                        <div class="mt-3 text-center sm:mt-0 sm:text-left">
                            <div
                                class="flex pb-3"
                                :class="{'border-gray-400 border-b': showHeaderDivider}"
                            >
                                <div class="flex-1 ml-4 sm:pb-2">
                                    <h3
                                        class="text-[20px] leading-6 font-bold text-black text-center"
                                        :class="{' ml-[25px]': showCloseButton, ' border-bottom border-gray-400 pb-4':showTitleBorderBottom}"
                                    >
                                        {{ title }}
                                    </h3>
                                </div>
                                <div
                                    v-if="showCloseButton"
                                    class="mr-4"
                                >
                                    <button
                                        data-accuid="Remind_Close"
                                        @click="onClickCloseButton"
                                    >
                                        <img
                                            src="@/assets/images/icons/close.svg"
                                            loading="lazy"
                                            alt="close"
                                        >
                                    </button>
                                </div>
                            </div>

                            <div class="mt-2 px-[20px]">
                                <!-- @slot 彈跳視窗 body -->                                
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 *  用於彈跳視窗的基本結構，樣式可參考 FIGMA 的 3.2.1，在桌機版和手機版上都是有限高度的視窗，背景自帶半透明整頁遮罩，此 component 並用於其他彈跳視窗 component 的基礎
 */
export default {
    name: 'CustomDialog',
    props: {
        /**
         * 彈跳視窗標題
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * 判斷是否需彈跳視窗關閉按鈕
         */
        showCloseButton: {
            type: Boolean,
            default: false
        },
        /**
         * 判斷是否顯示彈跳視窗標題下方分隔線
         */
        showTitleBorderBottom: {
            type: Boolean,
            default: false
        },
        /**
         * 判斷是否需彈跳視窗標題下方分隔線
         */
        showHeaderDivider: {
            type: Boolean,
            default: false
        },
        /**
         * 彈窗寬度尺寸
         */
        size: {
            type: String,
            default: 's',
        }
    },
    emits: ['close'],
    data() {
        return {
            width: {
                s: 'md:max-w-[576px]',
                m: 'md:max-w-[672px]',
                l: 'md:max-w-[1024px]',
            }
        };
    },

    mounted() {
        // 使 body 元素的內容禁止滾動，彈跳視窗顯示時，防止使用者通過滾動背景頁面造成網頁重新整理
        document.body.classList.add('overflow-hidden');
    },
    beforeUnmount() {
        // 使 body 元素的內容允許滾動
        document.body.classList.remove('overflow-hidden');
    },
    methods: {
        /**
         *  關閉彈跳視窗
         * 
         *  @public
         */
        onClickCloseButton() {
            /**
             *  關閉彈跳視窗
             */
            this.$emit('close');
        }
    }
};
</script>